/// <reference  types="@types/googlemaps"  />

import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter, Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import AutocompletePrediction = google.maps.places.AutocompletePrediction;
import PlacesServiceStatus = google.maps.places.PlacesServiceStatus;
import { LocationMessage, MapLocationData } from '../../../../../shared/models';

@Component({
  selector: 'app-show-location',
  templateUrl: './show-location.component.html',
  styleUrls: ['./show-location.component.scss'],
})
export class ShowLocationComponent implements AfterViewInit {
  @ViewChild('locationAutocompleteText', { static: true }) locationAutocomplete: ElementRef;
  @ViewChild('locationMap', { static: true }) locationMap: any;
  @ViewChild('infoWindowContent', { static: true }) infoWindowContent: any;
  @Output() onClickCancelView: any = new EventEmitter();
  @Output() onShareLocationClick: any = new EventEmitter<LocationMessage>();
  @Input() text: string = "Share"
  map: google.maps.Map;
  locationSearchValue: string;
  placeResultAddress: string;
  showPlacesDropdown: boolean;
  locationsData: MapLocationData[] = [];
  locationMessage: LocationMessage = {
    locationName: null,
    locationAddress: '',
    longitude: null,
    latitude: null,
  };
  private defaultLat: number = 37.52319;
  private defaultLon: number = -122.25918;
  private autocompleteService: google.maps.places.AutocompleteService;
  private placesService: google.maps.places.PlacesService;
  private marker: google.maps.Marker;

  ngAfterViewInit() {
    document.getElementById('location-input').focus();
    let $this = this;
    navigator.geolocation.getCurrentPosition(
      function (position) {
        $this.showMap(position.coords.latitude, position.coords.longitude);
      },
      function errorCallback(error) {
        $this.showMap($this.defaultLat, $this.defaultLon);
      }
    );
  }

  private showMap(lat: number, lon: number) {
    let pos = new google.maps.LatLng(lat, lon);

    let mapOptions: google.maps.MapOptions = {
      center: pos,
      zoom: 15,
      disableDefaultUI: true,
      mapTypeControl: false,
      scaleControl: true,
      zoomControl: false,
      keyboardShortcuts: false,
      streetViewControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [
        {
          featureType: 'poi',
          elementType: 'labels',
          stylers: [{ visibility: 'off' }],
        },
      ],
    };

    this.map = new google.maps.Map(this.locationMap.nativeElement, mapOptions);

    // Show locations dropdown on input event
    google.maps.event.addDomListener(this.locationAutocomplete.nativeElement, 'input', () => {
      this.getPlacePredictions(this.locationAutocomplete.nativeElement.value);
    });

    // Hide locations dropdown when click occurs out of the dropdown and inputs
    google.maps.event.addDomListener(document, 'click', (e) => {
      const target = e.target as HTMLElement;

      if (
        target.parentElement.className !== 'show-location-dropdown-content' &&
        target.parentElement.className !== 'show-location-dropdown-item' &&
        target.tagName !== 'INPUT'
      ) {
        this.showPlacesDropdown = false;
        this.locationsData = [];
      }
    });

    this.autocompleteService = new google.maps.places.AutocompleteService();
    this.placesService = new google.maps.places.PlacesService(this.map);
  }

  private getPlacePredictions(search: string) {
    if (!search || search.length == 0) {
      this.locationsData = [];
      this.showPlacesDropdown = false;
      return;
    }

    this.autocompleteService.getPlacePredictions(
      {
        input: search,
      },
      (predictions, status) => {
        this.showPlacePredictions(predictions, status);
      }
    );
  }

  private showPlacePredictions(predictions: AutocompletePrediction[], status: PlacesServiceStatus) {
    if (status != google.maps.places.PlacesServiceStatus.OK) {
      return;
    }

    this.locationsData = [];
    predictions.forEach((pr) => {
      let place: MapLocationData = {
        id: pr.place_id,
        address: pr.description,
        mainAddress: pr.structured_formatting.main_text,
        secondaryAddress: pr.structured_formatting.secondary_text
      };
      this.locationsData.push(place);
    });

    this.showPlacesDropdown = true;
  }

  inputLocation(event: any) {
    this.locationSearchValue = event.value;
  }

  toggleCancelView() {
    this.onClickCancelView.emit(true);
  }

  clearViewState() {
    this.locationSearchValue = '';
    this.locationAutocomplete.nativeElement.value = '';
    this.showPlacesDropdown = false;
    this.locationsData = [];
    if (this.marker) {
      this.marker.setMap(null);
    }
  }

  addMapLocation(selectedLocation: MapLocationData) {
    this.showPlacesDropdown = false;
    this.locationAutocomplete.nativeElement.value = selectedLocation.address;
    let request = { placeId: selectedLocation.id };
    this.placesService.getDetails(request, (placeResult, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        this.addMapLocationMarker(placeResult);
      }
    });
  }

  private addMapLocationMarker(placeResult: google.maps.places.PlaceResult) {
    let placeLocation = placeResult.geometry.location;
    this.marker = new google.maps.Marker({
      position: placeLocation,
      map: this.map,
      icon: 'assets/svg/redesign/map_marker_icon.svg',
    });

    this.locationMessage = {
      locationName: placeResult.name,
      locationAddress: placeResult.formatted_address,
      latitude: placeLocation.lat().toString(),
      longitude: placeLocation.lng().toString(),
    };

    let information = new google.maps.InfoWindow({
      content: this.infoWindowContent.nativeElement,
    });

    information.open(this.map, this.marker);

    this.map.setCenter(placeLocation);
    this.showPlacesDropdown = false;
  }

  shareLocation() {
    if (!this.locationMessage) {
      return;
    }
    this.onShareLocationClick.emit(this.locationMessage);
    this.toggleCancelView();
  }
}
